import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import ConceptPaperList from "./ConceptPaperList";
import styles from "./ConceptAcademicInformation.module.scss";
import ConceptPublicationList from "./ConceptPublicationList";
import ConceptAuthorList from "./ConceptAuthorList";
import ConceptInstitutionList from "./ConceptInstitutionList";
import ConceptUnitList from "./ConceptUnitList";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";
const ConceptAcademicInformation = () => {
  const [tab, setTab] = useState(0);
  const { isAuthLoading, userTypeConfig } = useAuth({
    entityType: "UNIT",
  });

  const tabs = [
    {
      label: "Survey Papers",
      key: "surveyPapers",
      children: <ConceptPaperList />,
    },
    {
      label: "Notable Publications",
      key: "notablePublications",
      children: <ConceptPublicationList />,
    },
    {
      label: "Top Authors",
      key: "authors",
      children: <ConceptAuthorList />,
    },
    {
      label: "Top Units",
      key: "units",
      children: userTypeConfig?.ui_components?.listView ? (
        <ConceptUnitList />
      ) : (
        <LoginRequiredSection />
      ),
    },
    {
      label: "Top Institutions",
      key: "institutions",
      children: <ConceptInstitutionList />,
    },
  ];

  const handleChange = (_, newValue) => {
    setTab(newValue);
  };

  return (
    <div className={styles["concept-academic-information"]}>
      <Tabs
        className={styles["tabs"]}
        value={tab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            label={tab.label}
            style={{ textTransform: "none" }}
          />
        ))}
      </Tabs>

      {tabs[tab]?.children}
    </div>
  );
};

export default ConceptAcademicInformation;
